import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
import { BiData } from '@wix/da-bi/pkg/events';
const ManageTier = ({ deviation  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(ListItem, {
        label: t('deviationview.tierCard.moreActionsMenu.item.unsubscribe'),
        onClick: ()=>window.location.assign(Url.account(deviation.deviationId)),
        biData: BiData({
            evid: 560,
            subscription_type: 'subscription'
        })
    });
};
ManageTier.displayName = 'ManageTier';
export default ManageTier;
